// extracted by mini-css-extract-plugin
module.exports = {"ldsRing":"AuthLoader_ldsRing__2k19m","loadingContainer":"AuthLoader_loadingContainer__S4CPz","type--DSA":"AuthLoader_type--DSA__CrWBb"};